/**
 * Generates a random integer in the range [0, limit - 1] that is not already
 * in `generatedNumbers`. Retries up to `limit` times before giving up and
 * returning -1, so callers should guard against that sentinel value.
 *
 * @param {number} limit - Upper bound (exclusive) for the random number.
 * @param {number[]} [generatedNumbers=[]] - Numbers to exclude from the result.
 * @returns {number} A unique random integer, or -1 if no unique value could be found.
 */
export function getUniqueRandomNumber(limit: number, generatedNumbers: number[] = []): number {
    const maxAttempts = limit;
    let randomNumber: number;
    let attempts = 0;
    do {
        randomNumber = Math.floor(Math.random() * limit);
        attempts++;
    } while (generatedNumbers.includes(randomNumber) && attempts < maxAttempts);
    if (attempts >= maxAttempts) {
        return -1;
    }
    return randomNumber;
}